var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('core-app-bar'),_c('core-drawer'),_c('notifications',{attrs:{"group":"notify","position":"center ","max":3,"width":500}}),_c('core-view'),_c('core-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }